import Vue from 'vue'
import Vuex from 'vuex'
import auth from './auth'
import device from './device'
import notifications from './notifications'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: { auth, device, notifications },
})
